<template>
	<div>
		<v-card style="padding-right: 20px; padding-top: 10px">

			<table>
				<tr style="font-weight: bold">
					<td>{{$t('pages.projectForm.branch')}}</td>
					<td>{{$t('pages.projectForm.address')}}</td>
					<td>{{$t('pages.clientTable.zipCode')}}</td>
					<td>{{$t('pages.projectForm.city')}}</td>
					<td>{{$t('pages.orderTable.tel')}}</td>
					<td>{{$t('pages.projectForm.contact')}}</td>
					<td>{{$t('attributes.email')}}</td>
					<td>{{$t('pages.measurementTable.actions')}}</td>
				</tr>
				<branch-row v-for="branch in client.branches" :branch="branch" @edit="$emit('branch', branch)" :key="branch.id"/>
			</table>



		</v-card>
	</div>
</template>

<script>
	import BranchRow from "dev/view/branches/BranchRow";

	export default {
		components: {BranchRow},
		props: ["client"],
		name: "client-expand"
	};
</script>

<style scoped>

</style>
